import { gql } from '@apollo/client';
import { categoryFragment } from '../fragments/category';

export const getSingleCategoryQuery = gql`
    ${categoryFragment}

    query GetSingleCategory($id: String!) {
        category(id: $id) {
            ...CategoryFields
        }
    }
`;
